'use client';

import { ReactNode } from 'react';

import { FieldInputProps, useField } from 'formik';
import { useMemo } from 'react';

interface IWithFormFieldCheckableProps {
  name: string;
  value?: string | number;
  children({
    field,
    value,
    checked,
    error
  }: {
    field: FieldInputProps<any>;
    value?: string | number;
    checked: boolean;
    error?: string;
  }): React.ReactNode;
  label?: ReactNode | (() => ReactNode);
  type?: 'checkbox' | 'radio';
}

export default function WithFormFieldCheckable({
  name,
  value,
  children
}: IWithFormFieldCheckableProps) {
  const [field, meta] = useField({ name, value });

  const checked = useMemo(() => {
    if (typeof field.value === 'boolean') return field.value;
    if (Array.isArray(field.value)) {
      return field.value.includes(`${value}`);
    }
    return field.value === `${value}`;
  }, [field.value, value]);

  return children({ field, value, checked, error: meta.error });
}
